import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import About from './components/About';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuy.hair';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY Sheet',
  alternateName: 'yoybuy.hair',
  url: siteUrl,
  description: 'YOYBUY Sheet — полное руководство по системе управления заказами из Китая. Узнайте, как использовать YOYBUY Spreadsheet, Kakobuy Spreadsheet и Superbuy Spreadsheet для выгодных покупок. Сравнение платформ, отзывы и статьи.',
  inLanguage: 'ru',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'yoybuy.hair',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <About />
      <ArticleGrid />
      <CTASection />
      <Testimonials />
      <Footer />
    </main>
  );
}